const pageStore = {
  state: {
    // currentPath: '/',
    currentPageTitle: 'Home',
  },

  reducers: {
    SET_CURRENT_PATH(state, payload) {
      const { currentPageTitle } = payload;
      return {
        ...state,
        // currentPath: payload,
        currentPageTitle,
      };
    },
  },
  effects: (dispatch) => ({
    setCurrentPath(payload) {
      dispatch.page.SET_CURRENT_PATH(payload);
    },
  }),
};

export default pageStore;
